import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5e2fcb06")
const _hoisted_1 = { class: "process-trace-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 506@2x.png",
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "farming-records" }
const _hoisted_4 = { class: "line1" }
const _hoisted_5 = { class: "medi-font" }
const _hoisted_6 = { class: "line2 litt-font" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", { class: "icons" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-shipinti1beifen3-copy" })
], -1)
const _hoisted_10 = { class: "durations medi-font" }
const _hoisted_11 = {
  key: 0,
  class: "line4"
}
const _hoisted_12 = {
  key: 1,
  class: "line5"
}
const _hoisted_13 = { class: "img-right" }
const _hoisted_14 = {
  key: 2,
  class: "count-img-num"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_preview_video = _resolveComponent("preview-video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processData, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "reco",
        key: item.id
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.processName), 1)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(item.processInfo), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fileVideos, (videos) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line3",
              key: videos.id
            }, [
              _createElementVNode("div", {
                class: "video-wrap",
                onClick: ($event: any) => (_ctx.onPreviewVideo(videos))
              }, [
                _createElementVNode("img", {
                  src: videos.coverImg
                }, null, 8, _hoisted_8),
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getDuration(videos.time)), 1)
              ], 8, _hoisted_7)
            ]))
          }), 128)),
          (item.fileVideos.length != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fileImgs, (items, nIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "img-wrap",
                    key: items.id
                  }, [
                    _createVNode(_component_van_image, {
                      class: "imgs",
                      radius: "0.625rem",
                      fit: "cover",
                      src: items.url+'?imageView2/1/w/200/h/200/rotate/0',
                      onClick: ($event: any) => (_ctx.onPreviewImg(nIndex, item.fileImgs))
                    }, null, 8, ["src", "onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (item.fileVideos.length == 0&&item.fileImgs.length != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_van_image, {
                  class: _normalizeClass(item.fileImgs.length != 0&&item.fileImgs.length > 1?'more-img':'only-img'),
                  onClick: ($event: any) => (_ctx.onPreviewImg(0, item.fileImgs)),
                  fit: "cover",
                  radius: "0.25rem",
                  src: item.fileImgs[0].url+ '?imageView2/2'
                }, null, 8, ["class", "onClick", "src"]),
                _createElementVNode("div", _hoisted_13, [
                  (item.fileImgs[1])
                    ? (_openBlock(), _createBlock(_component_van_image, {
                        key: 0,
                        class: "l5-img",
                        onClick: ($event: any) => (_ctx.onPreviewImg(1, item.fileImgs)),
                        fit: "cover",
                        radius: "0.25rem",
                        src: item.fileImgs[1].url+ '?imageView2/2'
                      }, null, 8, ["onClick", "src"]))
                    : _createCommentVNode("", true),
                  (item.fileImgs[2])
                    ? (_openBlock(), _createBlock(_component_van_image, {
                        key: 1,
                        class: "l5-img",
                        onClick: ($event: any) => (_ctx.onPreviewImg(2, item.fileImgs)),
                        fit: "cover",
                        radius: "0.25rem",
                        src: item.fileImgs[2].url+ '?imageView2/2'
                      }, null, 8, ["onClick", "src"]))
                    : _createCommentVNode("", true),
                  (item.fileImgs.length > 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.fileImgs.length) + "图", 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createVNode(_component_preview_video, {
      visible: _ctx.showVideos,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showVideos = $event)),
      url: _ctx.previewVideoUrl,
      autoplay: ""
    }, null, 8, ["visible", "url"])
  ]))
}